'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var errCode = require('err-code');

var UnixFS = require('ipfs-unixfs');

var findShardCid = require('../../utils/find-cid-in-shard');

var findLinkCid = function findLinkCid(node, name) {
  var link = node.Links.find(function (link) {
    return link.Name === name;
  });
  return link && link.Hash;
};

var contentExporters = {
  raw: require('./content/file'),
  file: require('./content/file'),
  directory: require('./content/directory'),
  'hamt-sharded-directory': require('./content/hamt-sharded-directory'),
  metadata: function metadata(cid, node, unixfs, path, resolve, depth, ipld) {},
  symlink: function symlink(cid, node, unixfs, path, resolve, depth, ipld) {}
};

var unixFsResolver = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid, name, path, toResolve, resolve, depth, ipld, options) {
    var node, unixfs, next, linkCid, nextName, nextPath;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return ipld.get(cid, options);

          case 2:
            node = _context.sent;

            if (!name) {
              name = cid.toBaseEncodedString();
            }

            _context.prev = 4;
            unixfs = UnixFS.unmarshal(node.Data);
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](4);
            throw errCode(_context.t0, 'ERR_NOT_UNIXFS');

          case 11:
            if (!path) {
              path = name;
            }

            if (!toResolve.length) {
              _context.next = 25;
              break;
            }

            if (!(unixfs && unixfs.type === 'hamt-sharded-directory')) {
              _context.next = 19;
              break;
            }

            _context.next = 16;
            return findShardCid(node, toResolve[0], ipld);

          case 16:
            linkCid = _context.sent;
            _context.next = 20;
            break;

          case 19:
            linkCid = findLinkCid(node, toResolve[0]);

          case 20:
            if (linkCid) {
              _context.next = 22;
              break;
            }

            throw errCode(new Error('file does not exist'), 'ERR_NOT_FOUND');

          case 22:
            // remove the path component we have resolved
            nextName = toResolve.shift();
            nextPath = "".concat(path, "/").concat(nextName);
            next = {
              cid: linkCid,
              toResolve: toResolve,
              name: nextName,
              path: nextPath
            };

          case 25:
            return _context.abrupt("return", {
              entry: {
                name: name,
                path: path,
                cid: cid,
                node: node,
                content: contentExporters[unixfs.type](cid, node, unixfs, path, resolve, depth, ipld, options),
                unixfs: unixfs,
                depth: depth
              },
              next: next
            });

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 8]]);
  }));

  return function unixFsResolver(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = unixFsResolver;